// export const Baseurl = "http://spektakulo.local";
export const Baseurl = "";
export const Entrypoint = Baseurl + "/api";
